import { z } from 'zod';

/**
 * A breaking-deploy maintenance window.
 * Unmounting all other Convex subscriptions until they OTA-update past it.
 */
export const breakingDeploySchema = z.object({
  /** When the operator armed the window (epoch ms). Shown on the maintenance screen. */
  startedAt: z.number(),
  /**
   * Minimum JS build version (GitHub run number) allowed through the gate.
   * Set to `null` to block all JS versions. Useful when manual DB changes need to be applied
   **/
  minJsVersion: z.number().nullable(),
});
export type BreakingDeploy = z.output<typeof breakingDeploySchema>;

export const platformGlobalSchema = z.object({
  /**
   * TODO:
   * It's problematic that we have multiple restaurants writing and reading from the same field in the database.
   * Renamed this table to `standalonePrinterLocalOrderIds` which list `restaurantId` and `standalonePrinterNextLocalOrderId` value.
   * This way each restaurant has it's own id that is updated independently.
   */
  standalonePrinterNextLocalOrderId: z.number().default(1000),
  breakingDeploy: breakingDeploySchema.nullable().default(null).optional(), // Remove optional after deploy
  _creationTime: z.number().optional(),
  _id: z.string().optional(),
  updatedAt: z.number().optional(),
});
export type PlatformGlobal = z.output<typeof platformGlobalSchema>;

export const platformGlobalStrictSchema = platformGlobalSchema;

export const platformGlobalCvxSchema = platformGlobalSchema.safeExtend({
  _creationTime: z.number(),
  _id: z.string(),
  updatedAt: z.number(),
});
export type PlatformGlobalCvx = z.output<typeof platformGlobalCvxSchema>;
